import React, { useContext } from 'react';
import { getSelectedOption } from '../../../../common/utils';
import { Grid, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { WindowSizeContext } from '../../../../common/context/WindowSizeContext';
import { styled } from "@mui/material/styles";


export default function ViewBySelector({ selectedViewBy, setSelectedViewBy }) {
    const windowSize = useContext(WindowSizeContext);
    const NewToggleButton = styled(ToggleButton)({
        width: windowSize?.isOnMobile ? '5rem' : '7rem',
        textTransform: 'capitalize',        
        color: '#0a4fb4',
        border: 0,
        borderRadius: '.25rem',
        backgroundColor: '#fff',
        borderBottom: 'none',
        '&:hover': {
            color: "#fff",
            backgroundColor: '#0a4fb4'
        },
        '&.Mui-selected, &.Mui-selected:hover': {
            color: "#fff",
            backgroundColor: '#0a4fb4'
        }, '&.MuiToggleButtonGroup-grouped:not(:last-of-type)': {
            borderRight: '.05rem solid lightgray',
            borderLeft: 'none'
        }, '&.MuiToggleButtonGroup-grouped:not(:first-of-type)': {
            marginLeft: 0
        },
        "&.Mui-disabled:hover": {
            backgroundColor: '#fff',
            color: '#00000042',
            cursor: 'not-allowed'
        }
    });

    const optionListGroup = [
        // NOTE: url value is for experimenting
        { value: "top_food_group", label: "Product Category", disabled: false },
        { value: "region", label: "Region", disabled: false },
        { value: "store_size", label: "Store Size", disabled: false },
        { value: "mall_type", label: "Store Type", disabled: false },
        { value: "mall_category", label: "Store Subtype", disabled: false }
    ];

    return (
        <Grid item xs={12} sm={9}>
            <Grid container xs={12} spacing={0}>
                {!windowSize.isOnMobile &&
                    <Grid item xs sm={2.5}>
                        <Typography variant="h6" ml={2.5}>
                            Inventory By
                        </Typography>
                    </Grid>
                }
                <Grid item xs={12} sm>
                    <ToggleButtonGroup
                        size="small"
                        color="primary"
                        exclusive
                        sx={{ flexWrap: "wrap"}}
                        value={selectedViewBy}
                        onChange={(event, value) => {
                            if (value !== null) {
                                setSelectedViewBy(value)
                            }
                        }}
                    >
                        {
                            optionListGroup.map(option => {
                                return <NewToggleButton value={option.value}disabled={option.disabled}>{option.label}</NewToggleButton>
                            })
                        }
                    </ToggleButtonGroup>
                </Grid>
            </Grid>
        </Grid>
    );
}